import { Row, Col, Image, Button } from 'react-bootstrap';
import usaFlag from './icons/usa.png';
import spaFlag from './icons/spanish.png';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import './LanguageSelector.css';

const LanguageSelector = ({ languages, variant = 'flags' }) => {
  const { changeLanguage, locale: currentLang, tempedgeTranslator } = useTempEdgeTranslator();

  if (variant === 'pills') {
    return (
      <span className="language-pills" role="group" aria-label={tempedgeTranslator('com.tempedge.msg.label.language')}>
        {languages.map((lang) => (
          <button
            key={lang.code}
            type="button"
            className={`language-pill ${currentLang === lang.code ? 'active' : ''}`}
            onClick={() => changeLanguage(lang.code)}
            data-testid={`language-selector-${lang.code}`}
          >
            {lang.code.toUpperCase()}
          </button>
        ))}
      </span>
    );
  }

  return (
    <Row className="align-items-center flex-nowrap language-selector-row">
      <Col xs="auto" className="language-text-col">
        <span className="language-text">{tempedgeTranslator('com.tempedge.msg.label.language')}</span>
      </Col>

      <Col xs="auto" className="language-flags-col">
        {languages.map((lang) => (
          <Button
            key={lang.code}
            variant="link"
            onClick={() => changeLanguage(lang.code)}
            className="language-flag-btn"
            data-testid={`language-selector-${lang.code}`}
          >
            <Image src={lang.code === 'en' ? usaFlag : spaFlag} alt="Country Flag" className="language-flag-img" />
          </Button>
        ))}
      </Col>
    </Row>
  );
};

export default LanguageSelector;
